"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactApollo = require("react-apollo");
var _reactRedux = require("react-redux");
var _clsx6 = _interopRequireDefault(require("clsx"));
var _commonLoader = require("@mmc/common-loader");
var _meetYourMatch = _interopRequireDefault(require("./meet-your-match.css"));
var _carousel = _interopRequireDefault(require("./carousel"));
var _seventhQuestionQuery = require("./seventhQuestionQuery");
var _CommonLoader, _Fragment, _Fragment2;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SelectedAnswerCard = function SelectedAnswerCard(_ref) {
  var backgroundurl = _ref.backgroundurl,
    id = _ref.id;
  var _useState = (0, _react.useState)('hidden'),
    visibility = _useState[0],
    setVisibility = _useState[1];
  var cardRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var visibilityTimer = setTimeout(function () {
      setVisibility(function () {
        return 'visible';
      });
    }, 0);
    setTimeout(function () {
      cardRef.current.style.transform = 'translateY(10px)';
      cardRef.current.style.opacity = '1';
    }, 0);
    return function () {
      clearTimeout(visibilityTimer);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: cardRef,
    id: id,
    style: {
      background: backgroundurl,
      visibility: visibility,
      transition: 'transform 0.8s ease-out, opacity 0.8s ease-out',
      transform: 'translateY(-30px)',
      opacity: 0
    }
  });
};
var OptionsCard = function OptionsCard(props) {
  var _clsx;
  var opObj = props.opDetails;
  var qIndex = props.qIndex;
  var opIndex = props.opIndex;
  var clickHandler = props.clickHandler;
  var answerSelection = props.selectedAnswersList;
  var isCenteredOnMobile = props.centered;
  var windowWidth = props.windowWidth;
  var isSingleSelectionQuestion = props.singleSelectionQuestion;
  var fourthQuestCheck = props.fourthQuestCheck;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].answerCards, (_clsx = {}, _clsx[_meetYourMatch["default"].zoomOnHover] = isSingleSelectionQuestion ? !("q" + (qIndex + 1) in answerSelection) || "q" + (qIndex + 1) in answerSelection && answerSelection["q" + (qIndex + 1)].length == 0 || answerSelection["q" + (qIndex + 1)][0].optionCode === opObj.optionCode : true, _clsx[_meetYourMatch["default"].disabledAnswerCard] = isSingleSelectionQuestion ? "q" + (qIndex + 1) in answerSelection && answerSelection["q" + (qIndex + 1)].length == 1 && answerSelection["q" + (qIndex + 1)][0].optionCode !== opObj.optionCode : false, _clsx)),
    style: {
      background: "url(" + opObj.bgImage + ")"
    },
    key: "q-" + qIndex + "-ac-" + opIndex,
    onClick: function onClick(e) {
      return windowWidth <= 768 && isCenteredOnMobile ? clickHandler(e, "q" + (qIndex + 1), opIndex, opObj) : windowWidth > 768 ? clickHandler(e, "q" + (qIndex + 1), opIndex, opObj) : '';
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].answerCardCta),
    style: {
      paddingBottom: windowWidth > 768 && opObj.optionName.length > 18 || windowWidth < 768 && opObj.optionName.length > 16 ? '6px' : '4px'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].heartIcon),
    style: {
      backgroundImage: answerSelection["q" + (qIndex + 1)] && answerSelection["q" + (qIndex + 1)].find(function (ans) {
        return ans.optionName.toLowerCase() === opObj.optionName.toLowerCase();
      }) ? "url(\"data:image/svg+xml,%3Csvg width='17' height='15' viewBox='0 0 15 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.1171 1.87142C11.7672 0.449317 9.61769 0.323926 8.12742 1.58009L7.23512 2.33244L6.34281 1.58009C4.85254 0.323926 2.70303 0.449317 1.35316 1.87142C-0.0216428 3.31981 -0.105029 5.60914 1.18354 7.08681C2.30463 8.37376 3.61101 9.79887 4.78698 10.8974C5.37638 11.4477 5.91661 11.9012 6.37346 12.2128C6.86665 12.5485 7.14247 12.6333 7.23512 12.6333C7.32777 12.6333 7.60358 12.5485 8.09678 12.2128C8.55362 11.9012 9.09385 11.4477 9.68326 10.8974C10.8592 9.79887 12.1656 8.37376 13.2867 7.08681C14.5745 5.60914 14.4919 3.31981 13.1171 1.87142Z' fill='white'/%3E%3C/svg%3E\")" : "url(\"data:image/svg+xml,%3Csvg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M14.3397 3.32078C12.9898 1.89868 10.8403 1.77329 9.35008 3.02945L8.45778 3.78179L7.56547 3.02945C6.07522 1.77329 3.92571 1.89868 2.57585 3.32078C1.20105 4.76915 1.11766 7.05848 2.40623 8.53614C3.52731 9.82308 4.83369 11.2482 6.00965 12.3467C6.59905 12.897 7.13928 13.3505 7.59612 13.6621C8.08931 13.9978 8.36513 14.0826 8.45778 14.0826C8.55043 14.0826 8.82624 13.9978 9.31943 13.6621C9.77627 13.3505 10.3165 12.897 10.9059 12.3467C12.0819 11.2482 13.3882 9.82308 14.5093 8.53614C15.7972 7.05848 15.7145 4.76915 14.3397 3.32078ZM8.45913 1.85663C10.5174 0.122927 13.4837 0.295621 15.3474 2.25833C17.2339 4.24656 17.3907 7.45041 15.5591 9.55203C14.4266 10.8517 13.0817 12.3211 11.8516 13.4707C11.238 14.0443 10.6364 14.5526 10.0926 14.9236C9.58591 15.269 9.00221 15.5843 8.45771 15.5843C7.9132 15.5843 7.3295 15.269 6.82277 14.9236C6.27898 14.5526 5.67746 14.0443 5.06382 13.4707C3.8337 12.3211 2.48883 10.8517 1.35635 9.55203C-0.475295 7.45041 -0.318501 4.24656 1.56802 2.25833C3.43174 0.295621 6.398 0.122927 8.45628 1.85663L8.45771 1.85813L8.45913 1.85663V1.85663Z' fill='white'/%3E%3C/svg%3E%0A\")"
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].answerCardCtaText)
  }, opObj.optionName)));
};
var MeetYourMatch = function MeetYourMatch(_ref2) {
  var _clsx2, _clsx3, _clsx4, _clsx5;
  var theme = _ref2.theme,
    data = _ref2.data,
    market = _ref2.market,
    language = _ref2.language,
    path = _ref2.path;
  var _useState2 = (0, _react.useState)(''),
    navHeight = _useState2[0],
    setNavHeight = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    screenBlur = _useState3[0],
    setScreenBlur = _useState3[1];
  var _useState4 = (0, _react.useState)(100 / 100),
    progressWidth = _useState4[0],
    setProgressWidth = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    progressedQuestion = _useState5[0],
    setProgressedQuestion = _useState5[1];
  var progressedQuestionRef = (0, _react.useRef)(0);
  var _useState6 = (0, _react.useState)(false),
    fullScreenActive = _useState6[0],
    setFullScreenActive = _useState6[1];
  var fullScreenActiveRef = (0, _react.useRef)(false);
  var fullscreenBtn = (0, _react.useRef)(null);
  var _useState7 = (0, _react.useState)(false),
    scrollBegin = _useState7[0],
    setScrollBegin = _useState7[1];
  var containerRef = (0, _react.useRef)(null);
  var screenContainerRef = /*#__PURE__*/(0, _react.createRef)();
  var centerOfScreenRef = /*#__PURE__*/(0, _react.createRef)();
  var finalAnswerScreen = /*#__PURE__*/(0, _react.createRef)();
  var nextSlideCtaContainerRef = (0, _react.useRef)();
  var prevSlideCtaContainerRef = (0, _react.useRef)();
  var isEventListenerConnected = (0, _react.useRef)(false);
  var exitedFrom7Screen = (0, _react.useRef)(false);
  var _useState8 = (0, _react.useState)({}),
    answerSelection = _useState8[0],
    setAnswerSelection = _useState8[1];
  var answerSelectionRef = (0, _react.useRef)({});
  var highestVehicleScoresRef = (0, _react.useRef)(null);
  var trimScoresRef = (0, _react.useRef)([]);
  var _useState9 = (0, _react.useState)({}),
    answerSelectionCard = _useState9[0],
    setAnswerSelectionCard = _useState9[1];
  var _useState0 = (0, _react.useState)(0),
    answerCarouselIndex = _useState0[0],
    setAnswerCarouselIndex = _useState0[1];
  var _useState1 = (0, _react.useState)(false),
    reachedFinalAnswerScreen = _useState1[0],
    setReachedFinalAnswerScreen = _useState1[1];
  var reachedFinalAnswerScreenRef = (0, _react.useRef)(false);
  var _useState10 = (0, _react.useState)(0),
    finalAnswerBgVideoIndex = _useState10[0],
    setFinalAnswerBgVideoIndex = _useState10[1];
  var _useState11 = (0, _react.useState)({}),
    questionsBgVideoIndex = _useState11[0],
    setQuestionsBgVideoIndex = _useState11[1];
  var lastQuestionRef = (0, _react.useRef)({});
  var _useState12 = (0, _react.useState)(false),
    lastQuestionQueryCompleted = _useState12[0],
    setLastQuestionQueryCompleted = _useState12[1];
  var logoText1 = (0, _react.useRef)(null);
  var _useState13 = (0, _react.useState)(false),
    showLogoText1 = _useState13[0],
    setShowLogoText1 = _useState13[1];
  var _useState14 = (0, _react.useState)('hidden hidden'),
    scrollingState = _useState14[0],
    setScrollingState = _useState14[1];
  var _useState15 = (0, _react.useState)(window.innerWidth),
    windowWidth = _useState15[0],
    setWindowWidth = _useState15[1];
  var _useState16 = (0, _react.useState)(true),
    fourthQuestCheck = _useState16[0],
    setFourthQuestCheck = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    progressBarHidden = _useState17[0],
    setProgressBarHidden = _useState17[1];

  // console.log('MeetYourMatch_1_0_0 >> data >>> ', data)

  var bgImage = data.bgImage,
    bgVideo = data.bgVideo,
    startScreenHeadline = data.headline,
    startScreenDescription = data.description,
    logoImage = data.logoImage,
    allQuestions = data.questions,
    optionSelectedLabel = data.optionSelectedLabel,
    singleOptionSelectionLabel = data.singleOptionSelectionLabel,
    multipleOptionSelectionLabel = data.multipleOptionSelectionLabel,
    startQuestionLabel = data.startQuestionLabel,
    previousQuestionLabel = data.previousQuestionLabel,
    nextQuestionLabel = data.nextQuestionLabel,
    finishQuestionLabel = data.finishQuestionLabel;
  var startScreenBgUrl = bgImage && bgImage.image;
  var starScreenLogoUrl = logoImage && logoImage.image;
  var getNavHeight = function getNavHeight() {
    return new Promise(function (resolve) {
      var headerElem = document.querySelector('header');
      var isNavHeader = Array.from(headerElem.classList).filter(function (c) {
        return c.match(/.*_navHeader_.*/g);
      });
      if (isNavHeader.length) {
        // new `IntersectionObserver` constructor
        var observer = new IntersectionObserver(function (entries) {
          // Loop through all `entries` returned by the observer
          // The `entry.boundingClientRect` is where all the dimensions are stored
          var bounds = entries[0].boundingClientRect;
          // Disconnect the observer to stop from running in the background
          observer.disconnect();
          resolve(bounds.height);
        });
        // Run the `observe` function of the `IntersectionObserver` on the element
        if (headerElem) {
          observer.observe(headerElem);
        }
      } else {
        resolve('');
      }
    });
  };
  (0, _react.useEffect)(function () {
    window.addEventListener("pageshow", function (event) {
      var historyTraversal = event.persisted;
      if (historyTraversal) {
        if ('meetYourMatchSelection' in window.localStorage) {
          window.localStorage.removeItem('meetYourMatchSelection');
        }
        // Handle page restore when clicking back button of browser
        window.location.reload();
      }
    });
    var getFooter = document.getElementsByTagName('footer');
    if (getFooter && getFooter.length) {
      getFooter[0].style.display = 'none';
    }
    allQuestions = allQuestions.map(function (q) {
      var optCount = 0;
      var modifiedOptions = q.options.reduce(function (acc, curr) {
        if (acc.filter(function (item) {
          return item.optionName === curr.optionName;
        }).length === 0) {
          var optionName = curr.optionName,
            optionCode = curr.optionCode,
            videoPath = curr.videoPath,
            imagePath = curr.imagePath,
            featureLabel = curr.featureLabel,
            featureDescription = curr.featureDescription,
            vehicleName = curr.vehicleName,
            vehicleYear = curr.vehicleYear,
            score = curr.score;
          acc.push({
            optionName: optionName,
            optionCode: optionCode,
            videoPath: videoPath,
            featureLabel: featureLabel,
            featureDescription: featureDescription,
            vehicles: [{
              vehicleName: vehicleName,
              vehicleYear: vehicleYear,
              score: score
            }],
            bgImage: imagePath
          });
          optCount++;
        } else {
          var index = acc.findIndex(function (item) {
            return item.optionName === curr.optionName;
          });
          var _vehicleName = curr.vehicleName,
            _vehicleYear = curr.vehicleYear,
            _score = curr.score;
          acc[index].vehicles.push({
            vehicleName: _vehicleName,
            vehicleYear: _vehicleYear,
            score: _score
          });
        }
        return acc;
      }, []);
      modifiedOptions == null ? void 0 : modifiedOptions.sort(function (a, b) {
        return a == null ? void 0 : a.optionCode.localeCompare(b == null ? void 0 : b.optionCode, 'en', {
          numeric: true
        });
      });
      q['modifiedOptions'] = modifiedOptions;
      setQuestionsBgVideoIndex(function () {
        var _Object$assign;
        return Object.assign(questionsBgVideoIndex, (_Object$assign = {}, _Object$assign[q.questionNumber] = 0, _Object$assign));
      });
      return q;
    });
    setQuestionsBgVideoIndex(function () {
      var _Object$assign2;
      return Object.assign(questionsBgVideoIndex, (_Object$assign2 = {}, _Object$assign2[allQuestions.length + 1] = 0, _Object$assign2));
    });
    getNavHeight().then(function (res) {
      // console.log('navHeight >> ', res)
      setNavHeight(res);
    });
    scrollTrigger('.screenDiv', {
      root: screenContainerRef.current,
      rootMargin: '2px',
      threshold: 1
    });
    if (logoText1.current) {
      var mobileNavHeightTimer = setTimeout(function () {
        getNavHeight().then(function (res) {
          // console.log('navHeight mobile >> ', res)
          setNavHeight(res);
        });
        clearTimeout(mobileNavHeightTimer);
      }, 200);
      setShowLogoText1(function () {
        return true;
      });
    }
    var handleWindowResize = function handleWindowResize() {
      setWindowWidth(window.innerWidth);
      // console.log('window.innerWidth >> ', window.innerWidth)
    };
    var handleProgressBarVisibility = function handleProgressBarVisibility() {
      var qIndex = progressedQuestionRef.current;
      if (qIndex > 0) {
        var ele = document.querySelectorAll('.meet-your-match__questionContainer___1Skn4')[qIndex - 1];
        if (ele) {
          setProgressBarHidden(ele && ele.scrollTop > 18);
        }
      }
    };
    window.addEventListener('resize', handleWindowResize);
    window.addEventListener('scroll', handleProgressBarVisibility, true);
    return function () {
      window.removeEventListener('resize', handleWindowResize);
      window.removeEventListener('scroll', handleProgressBarVisibility, true);
    };
  }, []);

  // const removeBlur = () => {
  //   setScreenBlur(false)
  // }

  var openFullScreen = function openFullScreen() {
    var getHeader = document.getElementsByTagName('header');
    var getNavSpacer = document.querySelector('div[class*="navigation-header__navHeaderSpacer"]');
    var getBreadcrumbNav = document.getElementsByTagName('nav');
    if (getHeader && getHeader.length) {
      getHeader[0].style.display = 'none';
    }
    if (getNavSpacer) {
      getNavSpacer.style.height = '0px';
    }
    if (getBreadcrumbNav && getBreadcrumbNav.length) {
      var breadcrumbNavElem = Array.from(getBreadcrumbNav).find(function (el) {
        return el.className.includes('breadcrumbNav');
      });
      if (breadcrumbNavElem) {
        breadcrumbNavElem.style.display = 'none';
      }
    }
    setNavHeight(function () {
      return 1;
    });
    setFullScreenActive(function () {
      return true;
    });
    fullScreenActiveRef.current = true;
  };
  var scrollTrigger = function scrollTrigger(selector, options) {
    if (options === void 0) {
      options = {};
    }
    var els = document.querySelectorAll(selector);
    els = Array.from(els);
    els.forEach(function (el) {
      addObserver(el, options);
    });
  };
  var addObserver = function addObserver(el, options) {
    if (!('IntersectionObserver' in window)) {
      // Simple fallback
      // The animation/callback will be called immediately so
      // the scroll animation doesn't happen on unsupported browsers
      if (options.cb) {
        options.cb(el);
      } else {
        // entry.target.classList.add('active')
      }
      // We don't need to execute the rest of the code
      return;
    }
    var observer = new IntersectionObserver(function (entries, observer1) {
      entries.forEach(function (entry) {
        // console.log('entry >> ', entry)
        // console.log('progressedQuestionRef.current >> ', progressedQuestionRef.current)
        if (entry.isIntersecting) {
          if (options.cb) {
            options.cb(el);
          } else if (0.99 - entry.intersectionRatio <= 0) {
            // console.log('entry.target >> ', entry.target)
            // console.log('entry.target.id >> ', entry.target.id)
            var targetId = entry.target.id;
            setAnswerCarouselIndex(0);
            if (targetId === 'startScreen') {
              setProgressedQuestion(function () {
                return 0;
              });
              progressedQuestionRef.current = 0;
              setProgressWidth(function () {
                return 100 / 100;
              });
              // scrolliing to START button
              setTimeout(function () {
                // console.log('Now scrolling to START btn')
                var startBtn = document.querySelector("." + _meetYourMatch["default"].startBtn);
                entry.target.parentElement.scrollIntoView(startBtn);
              }, 3800);
            } else if (targetId === 'finalAnswers') {
              openFullScreen();
              setReachedFinalAnswerScreen(function () {
                return Boolean(true);
              });
              reachedFinalAnswerScreenRef.current = true;
              if (fullScreenActiveRef.current) {
                entry.target.parentElement.style.overflow = 'hidden';
              }
              var allAnswerSelected = Object.keys(answerSelectionRef.current).reduce(function (acc, curr) {
                acc.push.apply(acc, answerSelectionRef.current[curr]);
                return acc;
              }, []);
              console.log('allAnswerSelected >> ', allAnswerSelected);
              setTimeout(function () {
                var queryParamObj = storeAnswerSelection();
                window.location.href = lastQuestionRef.current.recommendedVehicle + "?" + Object.keys(queryParamObj).map(function (key) {
                  return encodeURIComponent(key) + '=' + encodeURIComponent(queryParamObj[key]);
                }).join('&');
              }, (allAnswerSelected.length + 2) * 1000);
            } else {
              var queScreenNo = parseInt(targetId.match(/(\d+)/)[0]);
              // console.log('queScreenNo >> ', queScreenNo)
              setReachedFinalAnswerScreen(function () {
                return Boolean(false);
              });
              reachedFinalAnswerScreenRef.current = false;
              if (progressedQuestion < allQuestions.length + 2) {
                entry.target.parentElement.style.overflow = 'hidden';
                setProgressedQuestion(function () {
                  return queScreenNo;
                });
                progressedQuestionRef.current = queScreenNo;
              }
              setProgressWidth(function () {
                return 100 / (allQuestions.length + 2) * (queScreenNo + 1);
              });
            }
            // re-setting the 'back/next question' CTA to its original position
            if (targetId !== 'startScreen' && targetId !== 'finalAnswers') {
              var _queScreenNo = parseInt(targetId.match(/(\d+)/)[0]);
              var scrollCtaContainer = document.querySelector("#slideCtaContainer-q" + _queScreenNo);
              if (scrollCtaContainer) {
                var resetCtaTimer = setTimeout(function () {
                  scrollCtaContainer.style.transform = 'translateY(0px)';
                  scrollCtaContainer.style.opacity = 1;
                  clearTimeout(resetCtaTimer);
                }, 2500);
              }
            }
          }
        } else {
          // setting the 'back/next question' CTA to slightly lower 
          // and hide it immediately we move from one question to other
          var _targetId = entry.target.id;
          if (_targetId !== 'startScreen' && _targetId !== 'finalAnswers') {
            var _queScreenNo2 = parseInt(_targetId.match(/(\d+)/)[0]);
            var _scrollCtaContainer = document.querySelector("#slideCtaContainer-q" + _queScreenNo2);
            if (_scrollCtaContainer) {
              _scrollCtaContainer.style.transform = 'translateY(30px)';
              _scrollCtaContainer.style.opacity = 0;
            }
          }
        }
      });
    }, options);
    observer.observe(el);
  };
  var answerCardClickHandler = function answerCardClickHandler(e, qNo, opIndex, answerCardObj) {
    var elem = e.currentTarget;
    var answerSelected = answerCardObj;
    var limitedSelectionQuestions = ['2', '4', '7'];
    var tempFourthQuestCheck = true;
    // This Condition when we Deselect the selected option card
    if (qNo in answerSelection && answerSelection[qNo].length && answerSelection[qNo].map(function (ans) {
      return ans.optionName.toLowerCase();
    }).includes(answerSelected.optionName.toLowerCase())) {
      var _Object$assign3;
      if (qNo === "q" + allQuestions.length) {
        // console.log('setting LastQuestionQueryCompleted to false on unselection of Question 6')
        setLastQuestionQueryCompleted(function () {
          return false;
        });
      }
      // elem.classList.add(styles.animatePopUp)
      // const removingPopAnimation = setTimeout(() => {
      //   elem.classList.remove(styles.animatePopUp)
      //   clearTimeout(removingPopAnimation)
      // }, 600)
      elem.classList.remove(_meetYourMatch["default"].animateBorderGlow);
      elem.classList.add(_meetYourMatch["default"].animateBorderRemoving);
      var filteredAnswerSelection = answerSelection[qNo].filter(function (a) {
        return a.optionName.toLowerCase() !== answerSelected.optionName.toLowerCase();
      });
      var newAnswerSelectionObj = Object.assign(answerSelection, (_Object$assign3 = {}, _Object$assign3[qNo] = [].concat(filteredAnswerSelection), _Object$assign3));
      setAnswerSelection(function () {
        return newAnswerSelectionObj;
      });
      answerSelectionRef.current = newAnswerSelectionObj;
      var answersCardFilteredOut = answerSelectionCard[qNo].filter(function (a) {
        return a.answer.optionName.toLowerCase() !== answerSelected.optionName.toLowerCase();
      });
      setTimeout(function () {
        elem.style.border = '0px solid var(--mmc-white)';
        var transitionCard = document.querySelector("#" + qNo + "-sac-" + answerCardObj.optionCode);
        transitionCard.classList.add(_meetYourMatch["default"].animateSlideUp);
        setTimeout(function () {
          setAnswerSelectionCard(function () {
            var _Object$assign4;
            return Object.assign(_objectSpread({}, answerSelectionCard), (_Object$assign4 = {}, _Object$assign4[qNo] = [].concat(answersCardFilteredOut), _Object$assign4));
          });
        }, 0);
      }, 400);
      return;
    }
    var currQuestionInteger = qNo.match(/(\d+)/)[0];
    if (limitedSelectionQuestions.includes(currQuestionInteger) && qNo in answerSelection && answerSelection[qNo].length > 2) {
      tempFourthQuestCheck = false;
      setFourthQuestCheck(function () {
        return tempFourthQuestCheck;
      });
    }
    var checkingMultipleCategoryQuestion = currQuestionInteger > allQuestions.length ? lastQuestionRef.current.questions[0].questionType.toLowerCase() === 'multiple' : allQuestions[currQuestionInteger - 1].questionType.toLowerCase() === 'multiple';
    if ((checkingMultipleCategoryQuestion || !(qNo in answerSelection && answerSelection[qNo].length === 1)) && tempFourthQuestCheck) {
      var _Object$assign6;
      elem.classList.remove(_meetYourMatch["default"].animateBorderRemoving);
      elem.classList.add(_meetYourMatch["default"].animateBorderGlow);
      setTimeout(function () {
        elem.style.border = '2px solid var(--mmc-white)';
        setAnswerSelectionCard(function () {
          var _Object$assign5;
          if (!(qNo in answerSelectionCard)) {
            answerSelectionCard[qNo] = [];
          }
          return Object.assign(_objectSpread({}, answerSelectionCard), (_Object$assign5 = {}, _Object$assign5[qNo] = [].concat(answerSelectionCard[qNo], [{
            answer: answerSelected,
            backgroundUrl: elem.style.background
          }]), _Object$assign5));
        });
      }, 0);
      var copyAnswerSelection = answerSelection;
      if (!(qNo in copyAnswerSelection)) {
        copyAnswerSelection[qNo] = [];
      }
      var _newAnswerSelectionObj = Object.assign(_objectSpread({}, copyAnswerSelection), (_Object$assign6 = {}, _Object$assign6[qNo] = [].concat(copyAnswerSelection[qNo], [answerSelected]), _Object$assign6));
      setAnswerSelection(function () {
        return _newAnswerSelectionObj;
      });
      answerSelectionRef.current = _newAnswerSelectionObj;

      // re-setting the 'back/next question' CTA to its original position
      var scrollCtaContainer = document.querySelector("#slideCtaContainer-" + qNo);
      if (scrollCtaContainer && qNo in _newAnswerSelectionObj && _newAnswerSelectionObj[qNo].length === 1) {
        var resetCtaTimer = setTimeout(function () {
          scrollCtaContainer.style.transform = 'translateY(0px)';
          scrollCtaContainer.style.opacity = 1;
          clearTimeout(resetCtaTimer);
        }, 700);
      }
    }

    // last question related calculations
    if (qNo === "q" + allQuestions.length && "q" + allQuestions.length in answerSelectionRef.current && answerSelectionRef.current["q" + allQuestions.length].length) {
      var answerSelectionCopy = _objectSpread({}, answerSelectionRef.current);
      if ("q" + (allQuestions.length + 1) in answerSelection || "q" + (allQuestions.length + 1) in answerSelectionCopy) {
        delete answerSelectionCopy["q" + (allQuestions.length + 1)];
        setAnswerSelection(function () {
          return answerSelectionCopy;
        });
        answerSelectionRef.current = answerSelectionCopy;
      }
      // console.log('answerSelectionCard >> ', answerSelectionCard)
      var answerSelectionCardCopy = _objectSpread({}, answerSelectionCard);
      if ("q" + (allQuestions.length + 1) in answerSelectionCard) {
        delete answerSelectionCardCopy["q" + (allQuestions.length + 1)];
        setTimeout(function () {
          setAnswerSelectionCard(function () {
            return answerSelectionCardCopy;
          });
        }, 0);
      }
      highestVehicleScoresRef.current = null;
      var vehicleScores = Object.keys(answerSelectionRef.current).reduce(function (acc, curr) {
        var sumObj = answerSelectionRef.current[curr].reduce(function (a, c) {
          c.vehicles.map(function (v) {
            if (v.vehicleName in a) {
              a[v.vehicleName].score += Number(v.score);
            } else {
              a[v.vehicleName] = {
                year: Number(v.vehicleYear),
                score: Number(v.score)
              };
            }
          });
          return a;
        }, {});
        Object.keys(sumObj).map(function (vehicle) {
          if (vehicle in acc) {
            acc[vehicle].score += sumObj[vehicle].score;
          } else {
            acc[vehicle] = sumObj[vehicle];
          }
        });
        return acc;
      }, {});
      // console.log('vehicleScores >> ', vehicleScores)
      var maxScore = Math.max.apply(Math, Object.keys(vehicleScores).map(function (vehicle) {
        return vehicleScores[vehicle].score;
      }));
      var highScoringVehicle = Object.keys(vehicleScores).filter(function (vehicle) {
        return vehicleScores[vehicle].score === maxScore;
      });
      // console.log('highScoringVehicle >> ', highScoringVehicle)

      if (highScoringVehicle.length > 1) {
        var decidingAnswerSelection = answerSelectionRef.current['q3'];
        var sumObj = decidingAnswerSelection.reduce(function (a, c) {
          c.vehicles.map(function (v) {
            if (v.vehicleName in a) {
              a[v.vehicleName].score += Number(v.score);
            } else {
              a[v.vehicleName] = {
                year: Number(v.vehicleYear),
                score: Number(v.score)
              };
            }
          });
          return a;
        }, {});
        var _maxScore = Math.max.apply(Math, Object.keys(sumObj).map(function (vehicle) {
          return sumObj[vehicle].score;
        }));
        highScoringVehicle = Object.keys(sumObj).filter(function (vehicle) {
          return sumObj[vehicle].score === _maxScore;
        });
      }
      // console.log('answerSelectionRef.current >> ', answerSelectionRef.current)

      highestVehicleScoresRef.current = {
        vehicle: highScoringVehicle[0],
        year: vehicleScores[highScoringVehicle[0]].year,
        featureCategory: answerSelectionRef.current["q" + allQuestions.length][0].optionName
      };
      // console.log('highestVehicleScoresRef.current >> ', highestVehicleScoresRef.current)
    } else if (currQuestionInteger < allQuestions.length) {
      setLastQuestionQueryCompleted(function () {
        return false;
      });
      highestVehicleScoresRef.current = null;
    }
    if (qNo === "q" + (allQuestions.length + 1) && "q" + (allQuestions.length + 1) in answerSelectionRef.current && answerSelectionRef.current["q" + (allQuestions.length + 1)].length) {
      var trimScores = answerSelectionRef.current["q" + (allQuestions.length + 1)].reduce(function (acc, curr) {
        curr.trims.map(function (trim) {
          if (!(trim.trimName in acc)) {
            acc[trim.trimName] = Number(trim.score);
          } else {
            acc[trim.trimName] += Number(trim.score);
          }
        });
        return acc;
      }, {});
      // console.log('trimScores >> ', trimScores)
      var _maxScore2 = Math.max.apply(Math, Object.values(trimScores));
      var highScoringTrim = Object.keys(trimScores).filter(function (trim) {
        return trimScores[trim] === _maxScore2;
      });
      // console.log('highScoringTrim >> ', highScoringTrim)
      trimScoresRef.current = highScoringTrim;
    }
  };
  var handleBgVideoSwitch = function handleBgVideoSwitch(e) {
    var allVideosArray = e.target.parentElement.children;
    // console.log('before finalAnswerBgVideoIndex >> ', finalAnswerBgVideoIndex)
    var newIndex;
    if (finalAnswerBgVideoIndex === allVideosArray.length - 1) {
      newIndex = 0;
    } else {
      newIndex = finalAnswerBgVideoIndex + 1;
    }
    setFinalAnswerBgVideoIndex(function () {
      return newIndex;
    });
    // console.log('after newIndex >> ', newIndex)

    var nextVideoToPlay = allVideosArray[newIndex];
    // console.log('hidden currently playing ', e.target)
    // console.log('finalAnswer new bgVideo >> ', nextVideoToPlay)

    e.target.style.visibility = 'hidden';
    Array.from(allVideosArray).map(function (v, index) {
      if (index === newIndex) {
        v.play();
      } else {
        v.pause();
        v.currentTime = 0;
      }
    });
    nextVideoToPlay.style.visibility = 'visible';
  };
  var handleQuestionBgVideoSwitch = function handleQuestionBgVideoSwitch(e, qNo) {
    var allVideosArray = e.target.parentElement.children;
    // console.log('before finalAnswerBgVideoIndex >> ', finalAnswerBgVideoIndex)
    var newIndex;
    if (questionsBgVideoIndex[qNo] === allVideosArray.length - 1) {
      newIndex = 0;
    } else {
      newIndex = questionsBgVideoIndex[qNo] + 1;
    }
    setQuestionsBgVideoIndex(function () {
      var _Object$assign7;
      return Object.assign(questionsBgVideoIndex, (_Object$assign7 = {}, _Object$assign7[qNo] = newIndex, _Object$assign7));
    });
    // console.log('after newIndex >> ', newIndex)

    var nextVideoToPlay = allVideosArray[newIndex];
    // console.log('hidden currently playing ', e.target)
    // console.log('finalAnswer new bgVideo >> ', nextVideoToPlay)

    e.target.style.visibility = 'hidden';
    Array.from(allVideosArray).map(function (v, index) {
      if (index === newIndex) {
        v.play();
      } else {
        v.pause();
        v.currentTime = 0;
      }
    });
    nextVideoToPlay.style.visibility = 'visible';
  };
  var includeModifiedOption = function includeModifiedOption(queObj) {
    queObj.questions.map(function (que) {
      var optCount = 0;
      var modifiedOptions = que.options.reduce(function (acc, curr) {
        if (acc.filter(function (item) {
          return item.optionName === curr.optionName;
        }).length === 0) {
          var optionName = curr.optionName,
            optionCode = curr.optionCode,
            videoPath = curr.videoPath,
            imagePath = curr.imagePath,
            featureLabel = curr.featureLabel,
            featureDescription = curr.featureDescription,
            trimName = curr.trimName,
            score = curr.score;
          acc.push({
            optionName: optionName,
            optionCode: optionCode,
            videoPath: videoPath,
            featureLabel: featureLabel,
            featureDescription: featureDescription,
            trims: [{
              trimName: trimName,
              score: score
            }],
            bgImage: imagePath
          });
          optCount++;
        } else {
          var index = acc.findIndex(function (item) {
            return item.optionName === curr.optionName;
          });
          var _trimName = curr.trimName,
            _score2 = curr.score;
          acc[index].trims.push({
            trimName: _trimName,
            score: _score2
          });
        }
        return acc;
      }, []);
      que['modifiedOptions'] = modifiedOptions;
      return que;
    });
    lastQuestionRef.current = queObj;
  };
  var prevScreenScroll = function prevScreenScroll() {
    if (progressedQuestion > 1) {
      var heightOfContainer = screenContainerRef.current.getBoundingClientRect().height;
      // console.log('heightOfContainer >> ', heightOfContainer)
      var heightToScroll = heightOfContainer * (progressedQuestion - 1);
      // console.log('heightToScroll >> ', heightToScroll)
      screenContainerRef.current.style.overflow = 'hidden scroll';
      screenContainerRef.current.scrollTo(0, heightToScroll);
    }
  };
  var nextScreenScroll = function nextScreenScroll() {
    var heightOfContainer = screenContainerRef.current.getBoundingClientRect().height;
    var screenNo = progressedQuestion === 0 ? 1 : progressedQuestion;
    var heightToScroll;
    if (progressedQuestion >= 1) {
      heightToScroll = heightOfContainer * screenNo + Math.round(heightOfContainer / 2) + 10;
    } else {
      heightToScroll = heightOfContainer * screenNo;
    }
    // console.log('heightToScroll >> ', heightToScroll)
    screenContainerRef.current.style.overflow = 'hidden scroll';
    screenContainerRef.current.scrollTo(0, heightToScroll + 10);
  };
  var storeAnswerSelection = function storeAnswerSelection() {
    var resultingPageVariables = Object.keys(answerSelectionRef.current).filter(function (qNo) {
      return qNo !== "q" + (allQuestions.length + 1);
    }).reduce(function (acc, qNo) {
      var queInteger = qNo.match(/(\d+)/)[0];
      acc["question" + queInteger] = answerSelectionRef.current[qNo].map(function (ans) {
        return ans.optionName;
      });
      return acc;
    }, {});
    var shareableObj = {
      'mym_questions': resultingPageVariables,
      'mym_vehicle': highestVehicleScoresRef.current.vehicle,
      'mym_year': highestVehicleScoresRef.current.year,
      'mym_trimName': trimScoresRef.current[0] || ''
    };
    localStorage.setItem('meetYourMatchSelection', JSON.stringify(shareableObj));
    Object.keys(shareableObj).map(function (key) {
      if (typeof shareableObj[key] !== 'string') {
        shareableObj[key] = JSON.stringify(shareableObj[key]);
      }
    });
    return shareableObj;
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: containerRef,
    id: "mainContainer",
    className: (0, _clsx6["default"])(_meetYourMatch["default"].mainContainer)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    ref: centerOfScreenRef,
    style: {
      position: 'absolute',
      top: '38.7rem',
      left: '50%'
      // height: '32px',
      // width: '2px',
      // background: 'red',
      // zIndex: '5',
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].progressBar, (_clsx2 = {}, _clsx2[_meetYourMatch["default"].isHidden] = reachedFinalAnswerScreen || progressBarHidden, _clsx2))
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].progressStatus),
    style: {
      width: progressWidth + "%"
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    id: "screenContainer",
    ref: screenContainerRef,
    className: (0, _clsx6["default"])(_meetYourMatch["default"].container),
    style: {
      height: !fullScreenActive ? "calc(100vh - 50px + 2rem)" : '100vh',
      overflow: 'hidden',
      scrollSnapType: 'y mandatory'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])((_clsx3 = {}, _clsx3[_meetYourMatch["default"].startScreenContainer] = true, _clsx3), 'screenDiv'),
    id: "startScreen",
    style: {
      height: !fullScreenActive ? "calc(100vh - 50px + 2rem)" : '100vh'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].darkOverlay40)
  }), /*#__PURE__*/_react["default"].createElement("video", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].videoBackground),
    poster: startScreenBgUrl,
    src: bgVideo,
    autoPlay: true,
    muted: true,
    loop: true,
    playsInline: true,
    style: {
      zIndex: 1
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].textContainer)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      transition: 'transform 0.8s cubic-bezier(0, 0.63, 0.65, 1.07) 200ms',
      visibility: showLogoText1 ? 'visible' : 'hidden',
      transform: !showLogoText1 ? 'translateY(60px)' : 'translateY(0px)'
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].startScreenLogo),
    src: starScreenLogoUrl,
    alt: logoImage && logoImage.altText
  })), /*#__PURE__*/_react["default"].createElement("h1", {
    ref: logoText1,
    className: (0, _clsx6["default"])((_clsx4 = {}, _clsx4[theme.fontRegular] = true, _clsx4[theme.colorWhite] = true, _clsx4[_meetYourMatch["default"].startScreenHeading] = true, _clsx4)),
    style: {
      top: '60%',
      transition: 'transform 0.8s cubic-bezier(0, 0.63, 0.65, 1.07) 750ms, visibility 0.8s cubic-bezier(0, 0.63, 0.65, 1.07) 750ms',
      visibility: showLogoText1 ? 'visible' : 'hidden',
      transform: !showLogoText1 ? 'translateY(20px)' : 'translateY(0px)'
    }
  }, startScreenHeadline), /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _clsx6["default"])((_clsx5 = {}, _clsx5[theme.colorWhite] = true, _clsx5[theme.marginTop30] = true, _clsx5[_meetYourMatch["default"].startScreenSubheading] = true, _clsx5)),
    style: {
      maxWidth: '80%',
      lineHeight: '1.5rem'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      display: 'inline-block',
      width: '100%',
      transition: 'transform 0.8s cubic-bezier(0, 0.63, 0.65, 1.07) 1000ms, visibility 0.8s cubic-bezier(0, 0.63, 0.65, 1.07) 1000ms',
      visibility: showLogoText1 ? 'visible' : 'hidden',
      transform: !showLogoText1 ? 'translateY(20px)' : 'translateY(0px)'
    }
  }, startScreenDescription)), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].startScreenContinueLabel)
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].screenNavCta, _meetYourMatch["default"].startBtn),
    style: {
      transition: 'transform 0.8s cubic-bezier(0, 0.63, 0.65, 1.07) 1250ms, visibility 0.8s cubic-bezier(0, 0.63, 0.65, 1.07) 1250ms',
      visibility: showLogoText1 ? 'visible' : 'hidden',
      transform: !showLogoText1 ? 'translateY(20px)' : 'translateY(0px)'
    },
    onClick: nextScreenScroll
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontFamily: 'inherit'
    }
  }, startQuestionLabel))))), allQuestions && allQuestions.sort(function (a, b) {
    return a.questionNumber - b.questionNumber;
  }).map(function (qObj, qIndex) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        height: !fullScreenActive ? "calc(100vh - 50px + 2rem)" : '100vh',
        border: '0.1px solid'
      },
      className: (0, _clsx6["default"])(_meetYourMatch["default"].questionContainer, 'screenDiv'),
      id: "q" + (qIndex + 1),
      key: "q" + qIndex
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx6["default"])(_meetYourMatch["default"].darkOverlay)
    }), /*#__PURE__*/_react["default"].createElement("div", {
      id: "questionsBgVideoContainer"
    }, qObj.modifiedOptions && qObj.modifiedOptions.map(function (opt, optIndex) {
      return /*#__PURE__*/_react["default"].createElement("video", {
        key: "q" + (qIndex + 1) + "_opt" + optIndex,
        className: (0, _clsx6["default"])(_meetYourMatch["default"].videoBackground),
        src: opt.videoPath,
        autoPlay: optIndex === 0 ? true : false,
        muted: true,
        playsInline: true,
        onEnded: function onEnded(e) {
          return handleQuestionBgVideoSwitch(e, qObj.questionNumber);
        },
        style: {
          visibility: optIndex === 0 ? 'visible' : 'hidden'
        }
      });
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx6["default"])(_meetYourMatch["default"].questionTextContainer)
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: (0, _clsx6["default"])(theme.mmcMedium, _meetYourMatch["default"].questionNo),
      style: {
        transition: 'transform 0.8s cubic-bezier(0, 1.02, 0.65, 1.07) 500ms, visibility 0.8s cubic-bezier(0, 1.02, 0.65, 1.07) 500ms',
        visibility: progressedQuestion === qIndex + 1 ? 'visible' : 'hidden',
        transform: progressedQuestion !== qIndex + 1 ? 'translateY(30px)' : 'translateY(0px)'
      }
    }, "Question ", qIndex + 1, " of ", allQuestions.length + 1), /*#__PURE__*/_react["default"].createElement("p", {
      className: (0, _clsx6["default"])(_meetYourMatch["default"].questionText),
      style: {
        transition: 'transform 0.8s cubic-bezier(0, 1.02, 0.65, 1.07) 550ms, visibility 0.8s cubic-bezier(0, 1.02, 0.65, 1.07) 550ms',
        visibility: progressedQuestion === qIndex + 1 ? 'visible' : 'hidden',
        transform: progressedQuestion !== qIndex + 1 ? 'translateY(30px)' : 'translateY(0px)'
      }
    }, qObj.question), /*#__PURE__*/_react["default"].createElement("p", {
      className: (0, _clsx6["default"])(_meetYourMatch["default"].questionHint),
      style: {
        transition: 'transform 0.8s cubic-bezier(0, 1.02, 0.65, 1.07) 600ms, visibility 0.8s cubic-bezier(0, 1.02, 0.65, 1.07) 600ms',
        visibility: progressedQuestion === qIndex + 1 ? 'visible' : 'hidden',
        transform: progressedQuestion !== qIndex + 1 ? 'translateY(30px)' : 'translateY(0px)'
      }
    }, qObj.questionType.toLowerCase() === 'single' ? singleOptionSelectionLabel : qObj.questionType.toLowerCase() === 'multiple' ? multipleOptionSelectionLabel : '')), /*#__PURE__*/_react["default"].createElement(_carousel["default"], {
      key: "q" + qIndex,
      centerOfScreen: centerOfScreenRef,
      qNo: qIndex + 1,
      progressedQuestion: progressedQuestion,
      windowWidth: windowWidth,
      answerSelectionStatus: answerSelection,
      childrenMetadata: qObj.modifiedOptions,
      theme: theme
    }, qObj.modifiedOptions && qObj.modifiedOptions.map(function (opObj, opIndex) {
      return /*#__PURE__*/_react["default"].createElement(OptionsCard, {
        key: "q-" + qIndex + "-ac-" + opIndex,
        opDetails: opObj,
        qIndex: qIndex,
        opIndex: opIndex,
        clickHandler: answerCardClickHandler,
        singleSelectionQuestion: qObj.questionType.toLowerCase() === 'single' || false,
        selectedAnswersList: answerSelection,
        windowWidth: windowWidth,
        fourthQuestCheck: fourthQuestCheck
      });
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx6["default"])(_meetYourMatch["default"].answerSelectedTextContainer),
      style: {
        transition: 'visibility 0.1s linear 2500ms',
        visibility: progressedQuestion !== qIndex + 1 ? 'hidden' : 'visible'
      }
    }, qIndex + 1 === progressedQuestion && !reachedFinalAnswerScreen && answerSelectionCard["q" + progressedQuestion] && answerSelectionCard["q" + progressedQuestion].length ? /*#__PURE__*/_react["default"].createElement("span", {
      key: "q" + qIndex + "-st",
      className: (0, _clsx6["default"])(_meetYourMatch["default"].answerSelectedText)
    }, optionSelectedLabel) : '', /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx6["default"])(_meetYourMatch["default"].selectionCardDestinationRow),
      style: {
        transition: 'opacity 0.1s linear 2500ms',
        opacity: progressedQuestion !== qIndex + 1 ? '0' : '1'
      }
    }, qIndex + 1 === progressedQuestion && !reachedFinalAnswerScreen && answerSelectionCard["q" + progressedQuestion] && answerSelectionCard["q" + progressedQuestion].length ? answerSelectionCard["q" + progressedQuestion].map(function (card, acIndex) {
      return /*#__PURE__*/_react["default"].createElement(SelectedAnswerCard, {
        id: "q" + (qIndex + 1) + "-sac-" + card.answer.optionCode,
        key: "sac-" + card.answer.optionName,
        backgroundurl: card.backgroundUrl
      });
    }) : '')), /*#__PURE__*/_react["default"].createElement("div", {
      id: "slideCtaContainer-q" + (qIndex + 1),
      className: (0, _clsx6["default"])(_meetYourMatch["default"].nextSlideCtaContainer),
      style: {
        transition: 'transform 0.8s cubic-bezier(0, 1.02, 0.65, 1.07), visibility 0.8s cubic-bezier(0, 1.02, 0.65, 1.07), opcaity 0.8s cubic-bezier(0, 1.02, 0.65, 1.07)',
        height: '55px',
        visibility: !reachedFinalAnswerScreen && progressedQuestion > 0 ? 'visible' : 'hidden'
      }
    }, allQuestions && progressedQuestion === allQuestions.length && "q" + progressedQuestion in answerSelection && answerSelection["q" + progressedQuestion].length && !lastQuestionQueryCompleted ? _CommonLoader || (_CommonLoader = /*#__PURE__*/_react["default"].createElement(_commonLoader.CommonLoader, {
      transparent: true
    })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
      className: (0, _clsx6["default"])(_meetYourMatch["default"].screenNavCta, _meetYourMatch["default"].backBtn),
      onClick: prevScreenScroll,
      disabled: progressedQuestion === 1
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        fontFamily: 'inherit'
      }
    }, previousQuestionLabel)), /*#__PURE__*/_react["default"].createElement("button", {
      className: (0, _clsx6["default"])(_meetYourMatch["default"].screenNavCta, _meetYourMatch["default"].nextBtn),
      onClick: nextScreenScroll,
      disabled: progressedQuestion >= 1 ? Boolean(!("q" + progressedQuestion in answerSelection && answerSelection["q" + progressedQuestion].length)) : true
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        fontFamily: 'inherit'
      }
    }, nextQuestionLabel)))));
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: !fullScreenActive ? "calc(100vh - 50px + 2rem)" : '100vh',
      border: '0.1px solid'
    },
    className: (0, _clsx6["default"])(_meetYourMatch["default"].questionContainer, 'screenDiv'),
    id: "q" + (allQuestions && allQuestions.length + 1),
    key: "q" + (allQuestions && allQuestions.length)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].darkOverlay)
  }), highestVehicleScoresRef.current && /*#__PURE__*/_react["default"].createElement(_reactApollo.Query, {
    query: _seventhQuestionQuery.GET_QUESTION_QUERY,
    variables: {
      market: market,
      language: language,
      path: path,
      "selection": highestVehicleScoresRef.current
    },
    fetchPolicy: "network-only",
    onCompleted: function onCompleted(data) {
      // setLastQuestionQueryCompleted(() => true)
    }
  }, function (_ref3) {
    var queryData = _ref3.data,
      error = _ref3.error,
      loading = _ref3.loading,
      previousData = _ref3.previousData;
    setLastQuestionQueryCompleted(function () {
      return false;
    });
    if (loading) {
      // return <CommonLoader />;
      return _Fragment || (_Fragment = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null));
    }
    if (queryData && queryData.getTrimSelectorQuestions) {
      if (Object.keys(lastQuestionRef.current).length === 0) {
        includeModifiedOption(queryData.getTrimSelectorQuestions);
      }
      setLastQuestionQueryCompleted(function () {
        return true;
      });
      // console.log('while RENDERING >> lastQuestionRef.current >> ', lastQuestionRef.current)
      if (lastQuestionRef.current && lastQuestionRef.current.questions.length) {
        return lastQuestionRef.current.questions.map(function (qObj) {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
            id: "questionsBgVideoContainer"
          }, qObj.modifiedOptions && qObj.modifiedOptions.map(function (opt, optIndex) {
            return /*#__PURE__*/_react["default"].createElement("video", {
              key: "q" + (allQuestions.length + 1) + "_opt" + optIndex,
              className: (0, _clsx6["default"])(_meetYourMatch["default"].videoBackground),
              src: opt.videoPath,
              autoPlay: optIndex === 0 ? true : false,
              muted: true,
              playsInline: true,
              onEnded: function onEnded(e) {
                return handleQuestionBgVideoSwitch(e, qObj.questionNumber);
              },
              style: {
                visibility: optIndex === 0 ? 'visible' : 'hidden'
              }
            });
          })), /*#__PURE__*/_react["default"].createElement("div", {
            className: (0, _clsx6["default"])(_meetYourMatch["default"].questionTextContainer)
          }, /*#__PURE__*/_react["default"].createElement("p", {
            className: (0, _clsx6["default"])(theme.mmcMedium, _meetYourMatch["default"].questionNo),
            style: {
              transition: 'transform 0.8s cubic-bezier(0, 1.02, 0.65, 1.07) 500ms, visibility 0.8s cubic-bezier(0, 1.02, 0.65, 1.07) 500ms',
              visibility: progressedQuestion === allQuestions.length + 1 ? 'visible' : 'hidden',
              transform: progressedQuestion !== allQuestions.length + 1 ? 'translateY(30px)' : 'translateY(0px)'
            }
          }, "Question ", allQuestions.length + 1, " of ", allQuestions.length + 1), /*#__PURE__*/_react["default"].createElement("p", {
            className: (0, _clsx6["default"])(_meetYourMatch["default"].questionText),
            style: {
              transition: 'transform 0.8s cubic-bezier(0, 1.02, 0.65, 1.07) 550ms, visibility 0.8s cubic-bezier(0, 1.02, 0.65, 1.07) 550ms',
              visibility: progressedQuestion === allQuestions.length + 1 ? 'visible' : 'hidden',
              transform: progressedQuestion !== allQuestions.length + 1 ? 'translateY(30px)' : 'translateY(0px)'
            }
          }, qObj.question), /*#__PURE__*/_react["default"].createElement("p", {
            className: (0, _clsx6["default"])(_meetYourMatch["default"].questionHint),
            style: {
              transition: 'transform 0.8s cubic-bezier(0, 1.02, 0.65, 1.07) 600ms, visibility 0.8s cubic-bezier(0, 1.02, 0.65, 1.07) 600ms',
              visibility: progressedQuestion === allQuestions.length + 1 ? 'visible' : 'hidden',
              transform: progressedQuestion !== allQuestions.length + 1 ? 'translateY(30px)' : 'translateY(0px)'
            }
          }, qObj.questionType.toLowerCase() === 'single' ? singleOptionSelectionLabel : qObj.questionType.toLowerCase() === 'multiple' ? multipleOptionSelectionLabel : '')), /*#__PURE__*/_react["default"].createElement(_carousel["default"], {
            key: "q" + allQuestions.length + "_" + answerSelection["q" + allQuestions.length].optionName + "_q" + (allQuestions.length + 1),
            centerOfScreen: centerOfScreenRef,
            qNo: allQuestions.length + 1,
            progressedQuestion: progressedQuestion,
            windowWidth: windowWidth,
            answerSelectionStatus: answerSelection,
            childrenMetadata: qObj.modifiedOptions,
            theme: theme
          }, qObj.modifiedOptions && qObj.modifiedOptions.map(function (opObj, opIndex) {
            return /*#__PURE__*/_react["default"].createElement(OptionsCard, {
              key: "q-" + allQuestions.length + "-ac-" + opIndex,
              opDetails: opObj,
              qIndex: allQuestions.length,
              opIndex: opIndex,
              clickHandler: answerCardClickHandler,
              singleSelectionQuestion: qObj.questionType.toLowerCase() === 'single' || false,
              selectedAnswersList: answerSelection,
              windowWidth: windowWidth,
              fourthQuestCheck: fourthQuestCheck
            });
          })));
        });
      }
    }
    return _Fragment2 || (_Fragment2 = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null));
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].answerSelectedTextContainer),
    style: {
      transition: 'visibility 0.1s linear 2500ms',
      visibility: allQuestions && progressedQuestion !== allQuestions.length + 1 ? 'hidden' : 'visible'
    }
  }, allQuestions.length + 1 === progressedQuestion && !reachedFinalAnswerScreen && answerSelectionCard["q" + progressedQuestion] && answerSelectionCard["q" + progressedQuestion].length ? /*#__PURE__*/_react["default"].createElement("span", {
    key: "q" + allQuestions.length + "-st",
    className: (0, _clsx6["default"])(_meetYourMatch["default"].answerSelectedText)
  }, optionSelectedLabel) : '', /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].selectionCardDestinationRow),
    style: {
      transition: 'opacity 0.1s linear 2500ms',
      opacity: allQuestions && progressedQuestion !== allQuestions.length + 1 ? '0' : '1'
    }
  }, allQuestions.length + 1 === progressedQuestion && !reachedFinalAnswerScreen && answerSelectionCard["q" + progressedQuestion] && answerSelectionCard["q" + progressedQuestion].length ? answerSelectionCard["q" + progressedQuestion].map(function (card, acIndex) {
    return /*#__PURE__*/_react["default"].createElement(SelectedAnswerCard, {
      id: "q" + (allQuestions.length + 1) + "-sac-" + card.answer.optionCode,
      key: "sac-" + card.answer.optionName,
      backgroundurl: card.backgroundUrl
    });
  }) : '')), /*#__PURE__*/_react["default"].createElement("div", {
    id: "slideCtaContainer-q" + (allQuestions.length + 1),
    className: (0, _clsx6["default"])(_meetYourMatch["default"].nextSlideCtaContainer, _meetYourMatch["default"].lastQueCtaContainer),
    style: {
      transition: 'transform 0.8s cubic-bezier(0, 1.02, 0.65, 1.07), visibility 0.8s cubic-bezier(0, 1.02, 0.65, 1.07), opcaity 0.8s cubic-bezier(0, 1.02, 0.65, 1.07)',
      height: '55px',
      visibility: !reachedFinalAnswerScreen && progressedQuestion > 0 ? 'visible' : 'hidden'
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].screenNavCta, _meetYourMatch["default"].backBtn),
    onClick: prevScreenScroll
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontFamily: 'inherit'
    }
  }, previousQuestionLabel)), /*#__PURE__*/_react["default"].createElement("button", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].screenNavCta, _meetYourMatch["default"].nextBtn),
    onClick: nextScreenScroll
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontFamily: 'inherit'
    }
  }, finishQuestionLabel)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "screenDiv",
    style: {
      height: !fullScreenActive ? "calc(100vh - 50px + 2rem)" : '100vh',
      border: '0.1px solid'
    },
    id: "finalAnswers"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].darkOverlay)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    id: "finalAnswerBgVideoContainer"
  }, answerSelection && Object.keys(answerSelection).length && Object.keys(answerSelection).reduce(function (acc, curr) {
    var justVideoPath = answerSelection[curr].map(function (ans) {
      return ans.videoPath;
    });
    return [].concat(acc, justVideoPath);
  }, []).map(function (vPath, vIndex) {
    return /*#__PURE__*/_react["default"].createElement("video", {
      key: "finalScreen_v" + vIndex,
      className: (0, _clsx6["default"])(_meetYourMatch["default"].videoBackground),
      src: vPath,
      autoPlay: vIndex === 0 ? true : false,
      muted: true,
      playsInline: true,
      onEnded: handleBgVideoSwitch,
      style: {
        visibility: vIndex === 0 ? 'visible' : 'hidden'
      }
    });
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].answerScreenContainer)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].answerScreenCenterDiv),
    ref: finalAnswerScreen
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _clsx6["default"])(_meetYourMatch["default"].answerScreenChilds),
    style: {
      visibility: reachedFinalAnswerScreen ? 'visible' : 'hidden',
      transform: reachedFinalAnswerScreen ? 'translateY(0px)' : 'translateY(30px)',
      transition: 'all 700ms cubic-bezier(0.21, 0.51, 0, 0.94)'
    }
  }, language === 'fr' ? 'Pour...' : 'For...'), /*#__PURE__*/_react["default"].createElement("ul", {
    id: "allAnswerLists",
    className: (0, _clsx6["default"])(_meetYourMatch["default"].allAnswerLists)
  }, Object.keys(answerSelection).reduce(function (acc, curr) {
    acc.push.apply(acc, answerSelection[curr]);
    return acc;
  }, []).map(function (ans, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: ans.optionName,
      style: {
        visibility: reachedFinalAnswerScreen ? 'visible' : 'hidden',
        transform: reachedFinalAnswerScreen ? 'translateY(0px)' : 'translateY(30px)',
        transition: "all 700ms cubic-bezier(0.21, 0.51, 0, 0.94) " + (index + 1) * 700 + "ms"
      }
    }, "" + (ans == null ? void 0 : ans.optionName.toLowerCase()));
  })))))));
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language
  };
};
MeetYourMatch.resourceType = function () {
  return 'MeetYourMatch_1_0_0';
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(MeetYourMatch);
exports["default"] = _default;